export default function InputCode(props: { onShowKeyboard: () => void }) {
  return (
    <div
      onClick={props.onShowKeyboard}
      className="click-effect flex h-24 w-full cursor-pointer items-center justify-center rounded-lg border border-silver"
    >
      <div className="text-2xl font-bold">Input gift card code</div>
    </div>
  );
}
